import React from 'react';
import { useQuery } from '@apollo/client';
import { Field } from 'formik';
import ReactSelect from 'components/Fields/ReactSelect';
import Loader from 'components/common/Loader';
import { ROLES_LIST } from 'utils/CommonGraphQL';
import { role } from 'config/role';
import { modifiedUnderScore } from 'utils/constants';

const RolesField = (props) => {
  const { data, loading, error } = useQuery(ROLES_LIST, {
    variables: {
      filter: [],
      pageNo: 0,
      pageSize: 30,
      sortCol: null,
      sortDirection: null,
    },
    fetchPolicy: 'network-only',
  });
  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;

  const filteredRoles = data?.roles?.filter(
    (rle) => rle?.name !== role.SUPER_ADMIN && rle?.name !== role.TRADER,
  );
  return (
    <div>
      <Field
        component={ReactSelect}
        data={filteredRoles}
        keys={{ id: 'id', label: 'label' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => modifiedUnderScore(option.name)}
        {...props}
      />
    </div>
  );
};

export default RolesField;
